import { render, staticRenderFns } from "./menu_cms.vue?vue&type=template&id=8d88fa30&"
import script from "./menu_cms.js?vue&type=script&lang=js&"
export * from "./menu_cms.js?vue&type=script&lang=js&"
import style0 from "../../../sass/main.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports